<div class="userInfo">
    @if (heading()) {
        <h2 class="heading">{{ heading() }}</h2>
    }
    @if (subheading()) {
        <span class="subheading">
            <lib-badge
                [text]="subheading()"
                libTooltip
                [tooltip]="tooltip()"
                [useParentForPositioning]="tooltipUseParentForPositioning()"
                [color]="'quaternary'"
            ></lib-badge>
        </span>
    }
</div>
